export enum ShareTypes {
  BareButton = 'bare-button',
  Dropdown = 'dropdown',
  IconOnly = 'icon-only',
  Link = 'link',
  None = 'none',
  OutlinedButton = 'outlined-button',
}
